module.exports = __webpack_public_path__ + "static/img/classVideo6.9780ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/classVideo6.png
// module id = MQ9X
// module chunks = 1